import { render, staticRenderFns } from "./InputSelectProject.vue?vue&type=template&id=bcce4fd0&"
import script from "./InputSelectProject.vue?vue&type=script&lang=ts&"
export * from "./InputSelectProject.vue?vue&type=script&lang=ts&"
import style0 from "./InputSelectProject.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports